<script>
export default {
    name: "PrintVisit",

    data() {

        return {
            visit: { specificVisitRecord: {}, charges: [] },
        };
    },

    mounted() {

        this.fetchVisit().then(() => {
            window.print();
            window.onafterprint = () => window.close();
        });
    },

    methods: {

        fetchVisit() {

            return this.$http.get(`Visits/GetSpecificPatientVisit?VisitId=${this.$route.params.visitID}`).then(response => {
                this.visit = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap text-gray-900">
        <tail-address-header></tail-address-header>
        <div class="w-full my-2 text-center p-1">
            <h5 class="font-bold">PATIENT VISIT NOTE</h5>
        </div>
        <div class="w-full flex flex-row px-1 border-t-2 border-gray-400 mt-1">
            
            <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">Name: {{ visit.specificVisitRecord && visit.specificVisitRecord.names }}</h5>
            </div>
            <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">MRN: {{ visit.specificVisitRecord && visit.specificVisitRecord.patienT_ID }}</h5>
            </div>
            <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">Date: {{ visit.specificVisitRecord && visit.specificVisitRecord.sysDate | dateFormat }}</h5>
            </div>
            <div class="flex-1 my-1 text-sm">
                <h5 class="font-semibold">Clinic: {{ visit.specificVisitRecord && visit.specificVisitRecord.clinic }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Doctor: {{ visit.specificVisitRecord && visit.specificVisitRecord.doctor }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Payment Mode: {{ visit.specificVisitRecord && visit.specificVisitRecord.pMode }}</h5>
            </div>
        </div>
        <table class="table mt-1">
            <thead class="text-sm">
                <tr class="border-b-2">
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Qty</th>
                    <th class="p-tiny">Charges</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr class="border-b-2" v-for="(visitCharge, idx) in visit.visitCharges" :key="idx">
                    <td class="p-tiny">{{ visitCharge.itemName }}</td>
                    <td class="p-tiny">{{ visitCharge.qty }}</td>
                    <td class="p-tiny">{{ visitCharge.charges | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
        <div class="w-full my-1 text-right">
            <h5 class="font-semibold">Visited By: {{ visit.specificVisitRecord.userName }}</h5>
        </div>
    </div>
</template>
